var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemintegrationandsupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 66,
    viewBox: "0 0 53 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "system_integration_and_support",
    "data-name": "system integration and support"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_3607544701594941675-128",
    "data-name": "3607544701594941675-128",
    x: 7,
    y: 10,
    width: 39,
    height: 46,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAuCAYAAACrrAD9AAADWUlEQVRYhe2ZbWjNURzHP7uRSRG2kKyVp8xTpBZ5Y9SKRIkpY2YeMnnBC5Q8TMpTGxOx8rQwyouVSJhNIjKyF2se8mx4Qd54gc1Tv/qddXb633v/9+5/d/di3/rX//z+5/zO5577P+f8zu+fEiqsIA7lAtOAGUAGMAwIWW7+Ah/0ugfUAddj7SYWuEHAGmApMCKOH/QSqAKOA5/9NAj5rLMNeA6UxAmGttsOPAV2AD2jNegR5fkU4CQwwePZK6AWaASagC/AL6AXkA5kAeOAHGC41a4fsBNYAKwAHsUDtxw47WE/C1QCt6L8sBrrfhZQAORbtvFAvfZT6eUg3N+60QNMRikbWOYDzAtU3tWpwG3n2RntzxfcaqDUsW0CZgIPY4Ry9UBn+BbHXqr9RoST5cGevv+AucCBDkK52gfMc2wV2r8nXCpwxWmQ62ELSpeB2Y5N+urtBXcE6G+Vi4CbCQIzugYUW2Xp/7ALN1phjC4BpxIMZnRMR9FoJTDKhttlPfzhgHaGCoEWq58SAycL5kLrwUHgeyfDfdPXymiRcAncYtlj1dgKHOpkMKNSDRjQQcsL6Yw0uqHbUDL0SaMXo9yQrvpGV5MEZmQvW9kCl2YZniSHqU2Prft0e51r1UjDVmqCYVz/EvP9MQUb7qO+b5OBoxoxNOtoZgUMNRZoUP/1OlMnaRDabCq5IdM5YIljGwisBdYHCCf+Jlr+JW5cB5y3K9lwmXp5KSWMPWi1Gxg/YTr6PgYpX/78wiVF3XDxqhsuXnXDxauQJlq6LJx7huwqahG4u0mMfiOpwbxzG/QUFE59Au7Yj78ae0IU68bb5FHxRYBgXv4khvvq2C64IVOVXjmaGhgKvAPKA4Yr1/ycZEWf6dml2orKJafSGC4FVqtXoiRRyR7Ld5Ee7I220kXWOQk0T1jltoFJNlyGRyK7wNwkE24McB8YYNnyI50hOqKRwJww7SVR89oq52mu2V5Sdkc6Q3REaZp47hvGh+xCg4EhQJmmQGyVaca+nYKCy4wAhn7DqNYlyq23Gdjv1SgouN8+6sx3ym+BVU7WvZ2CmhCxHB1/Anv120ZYMAIcOUlsR9N74KJ+Xnrjx2lQcLJXSnQzXcuSZ5MlQT7Mif2OrmdteZCoAv4DENubFmIA8hAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemintegrationandsupport);
export default __webpack_public_path__ + "static/media/system integration and support.bd81fd609573a7ed52fbcbec529f080e.svg";
export { ForwardRef as ReactComponent };